import React, { useState } from 'react';
import { Button } from "antd";
import { StyledModal } from './StyledModal';

type RegistrationLinkInfoProps = {
    headline: string,
    link: string,
    description?: string,
    onClose: () => void,
    isOpen: boolean
}

export const RegistrationLinkInfo = ({headline, link, description, onClose, isOpen} : RegistrationLinkInfoProps) => {
    const [copyStatus, setCopyStatus] = useState<string>('');

    const copyLinkHandle = () => {
        navigator.clipboard.writeText(link).then(function() {
            setCopyStatus('Ссылка успешно скопирована в буфер обмена');
          }, function(err) {
            setCopyStatus(`Произошла ошибка при копировании ссылки: ${err}`);
          });
    }

    const closeHandler = () => {
        setCopyStatus('');
        onClose();
    }

    return (
        <StyledModal 
            title={headline}
            open={isOpen}
            footer={[
                <Button onClick={closeHandler} style={{marginRight: '6px'}} key="close">
                    Закрыть окно
                </Button>,
                <Button type="primary" onClick={copyLinkHandle} key="copy">
                    Скопировать ссылку в буфер обмена
                </Button>
            ]}
            onCancel={closeHandler}
        >
            <p> {link} </p>
            <p> {description} </p>
            <p> {copyStatus} </p>
        </StyledModal>
    )
}